import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { WizardType } from 'components/Wizards/schemas/Types'

export const WIZARD_TOUR_PORTAL_ID = 'wizard-tour-portal-id'
export const WIZARD_TOUR_HELP_MENU_PORTAL_ID = 'wizard-tour-help-menu-portal-id'

// Exclude ChannelType.FacebookPost because it maps to the same value as DesignChannel.FacebookPost
export const WIZARD_VIDEO_MAP: Partial<Record<Exclude<WizardType, ChannelType.FacebookPost>, string>> = {
  [DesignChannel.InstagramPost]: '2AjJrOSr8AY',
  [ChannelType.InstagramPosts]: '2AjJrOSr8AY',
  [DesignChannel.FacebookCover]: 'Rvd2l7od8RM',
  [DesignChannel.LinkedInProfilePicture]: '9nW0Dp7IMDM',
  [DesignChannel.WhatsAppSticker]: 'S1gD0rZp3bA',
  [DesignChannel.FacebookPost]: 'Libtt77xuS8',
  [DesignChannel.LinkedInPost]: 'RYIqeRuyqE0',
  [ChannelType.LinkedInPosts]: 'RYIqeRuyqE0',
  [ChannelType.FacebookAds]: '80qZH5Ke3Ng',
  [ChannelType.ProductLaunchWebsite]: 'JQn2ebwsVRo', // Marketplace copy
  [ChannelType.ProductLaunchAmazon]: 'JQn2ebwsVRo', // Marketplace copy
  [ChannelType.ProductLaunchEtsy]: 'JQn2ebwsVRo', // Marketplace copy
  [ChannelType.ProductLaunchGoogle]: 'JQn2ebwsVRo', // Marketplace copy
  [ChannelType.ProductLaunchShopify]: 'JQn2ebwsVRo', // Marketplace copy
  [DesignChannel.Shopify]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Etsy]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Amazon]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Ebay]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Depop]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Poshmark]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Mercari]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.MercadoLibre]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Shopee]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Lazada]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.Vinted]: 'op-jv5exP4k', // Marketplace visual
  [DesignChannel.FacebookMarketplace]: 'op-jv5exP4k', // Marketplace visual
  [ChannelType.BlogPost]: 'LyB-S1EW-1k',
  [ChannelType.Newsletter]: 'I9FmcqolZNA',
  [GenerationType.InstagramPlanning]: '7GudE5YqAwc', // Multi-planning
  [GenerationType.LinkedInPlanning]: '7GudE5YqAwc', // Multi-planning
  [GenerationType.FacebookPlanning]: '7GudE5YqAwc', // Multi-planning
  [GenerationType.TwitterPlanning]: '7GudE5YqAwc', // Multi-planning
  [ChannelType.BlogIdeas]: 'Glupb9X4KLk',
  [GenerationType.Brainstorm]: 'Glupb9X4KLk',
  [GenerationType.ContentBrief]: 'rvLR-HLMm1Y',
  [ChannelType.LandingPage]: 'zUaaZnRCcAc',
  [ChannelType.OnePager]: '6hg6-lJ22Gs',
  [ChannelType.YoutubeScript]: 'xcPCiBAoFRA',
}

export interface Props {
  type: WizardType
}
